<template>
    <div v-if="Object.keys(this.carPackage.extraEquipment).length" class="card mb-4">
        <div class="card-header">
            <h2 class="card-title">{{ $t('cars.checkout.equipment.panelTitle') }}</h2>
        </div>
        <div class="alert alert-secondary alert-flush">
            {{ $t('cars.checkout.equipment.equipmentNotice') }}
            <div v-if="!carPackage.isInLocalCurrency"
                 v-html="$t('cars.checkout.equipment.currencyNotice', {
                      currency: carPackage.currency,
                      interpolation: {escape: function escape(str) { return str; }}
                 })">
            </div>
        </div>
        <table class="table table-bordered table-border-outer-0 mb-0">
            <tr v-for="extra in carPackage.extraEquipment">
                <th class="td-shrink">{{ extra.title }}</th>
                <td>{{ extra.description }}</td>
                <td class="td-shrink">
                    {{extra.price | formatMoney(extra.currency) }} {{ extra.currency }}
                    <span v-if="extra.taxInclusive" class="text-muted">
                        {{ $t('cars.checkout.equipment.taxExcl') }}
                    </span>
                </td>
                <td style="width: 15%">
                    <input type="number"
                           min="0"
                           :max="extra.maximumQuantity"
                           class="form-control"
                           v-model="extraEquipment[extra.type]"
                           @input="changeExtras"
                           v-validate="'equip-' + extra.type">
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
    export default {
        name: 'ExtraEquipment',
        props: ['carPackage', 'errors'],
        data() {
            return {
                extraEquipment: {}
            };
        },
        methods: {
            setup() {
                let extraEquipment = {};
                for (let i in this.carPackage.extraEquipment) {
                    let extra = this.carPackage.extraEquipment[i];
                    extraEquipment[extra.type] = this.extraEquipment[extra.type] || 0;
                }
                this.extraEquipment = extraEquipment;
            },
            changeExtras() {
                this.$emit('extras-changed', this.extraEquipment);
            }
        },
        watch: {
            carPackage() {
                this.setup();
            }
        },
        mounted() {
            this.setup();
        }
    };
</script>

<style scoped>

</style>